import React from "react"
import {FieldFormElementProps} from "../../../../render/form-elemnent"
import FieldTags_FormView from "./form-view"
import FieldTags from "../../tags"

export default function FieldTags_FormElement(props: FieldFormElementProps) {

    const onChange = (value: any) => {
        if (props.form) {
            props.form.onFormComponentValueChange(props.field.fieldId, value)
        }
    }

    return (
        <FieldTags_FormView
            className           = {props.className}
            field               = {props.field as unknown as FieldTags}
            value               = {props.form.getValue(props.field.fieldId)}
            disabled            = {props.disabled}
            onChange            = {onChange}
            onImmediateChange   = {onChange}
        />
    )
}
